// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.version {
  position: absolute;
  bottom: 0;
  left: 0;
  padding-bottom: 0px;
  color: white;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/components/side-bar/side-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AACJ","sourcesContent":[".version {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    padding-bottom: 0px;\n    color: white;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
